/* provides dynamic max-height for the use of transition animations, which natively cannot use %s to handle variable content heights */
function setExpandableContentMaxHeight() {
    $('.wide-card-row .expandable-hover').each(function () {
        var element = $(this)[0];
        var height = element.scrollHeight;
        $(this).css('--max-height', height + 'px')
    });
};

$(document).ready(function () {
    setExpandableContentMaxHeight();

    $(window).on('resize', throttle(function () {
        setExpandableContentMaxHeight();
    }, 400));
});